/**
 * Relationship types for authorized persons
 * Fixed dropdown options for consistency
 */
export const RELATIONSHIP_OPTIONS = [
  'Parent',
  'Guardian',
  'Grandparent',
  'Sibling',
  'Aunt/Uncle',
  'Nanny',
  'Babysitter',
  'Friend',
  'Neighbor',
  'Other',
] as const;

export type RelationshipType = typeof RELATIONSHIP_OPTIONS[number];
